<div class="container container-main">
  <app-dashboard-header #dashboardHeader :dashboardType="leader" />
  <div class="row gy-3">
    <div class="col-xl-8">
      <ng-container *ngIf="smartAssistantEnabled">
        <div class="row gy-3 mb-3">
          <div class="col">
            <app-glai />
          </div>
        </div>
      </ng-container>
      <div class="row gy-3 mb-3">
        <div class="col">
          <div class="h-100">
            <app-card-leader-glance
              *ngIf="reportingYear"
              [sessionParams]="yearToDateSessionParams"
              [obvservationParams]="yearToDateObservationParams"
              [trainingEventParams]="yearToDateTrainingEventParams"
              [strandBadgeParams]="yearToDateStrandBadgeParams"
              [microcredentialParams]="yearToDateMicrocredentialParams"
              [giParams]="yearToDateGIParams"
              [celebrationParams]="yearToDateCelebrationParams"
              [coachedParams]="peopleCoachedParams"
              [campusParams]="yearToDateCampusParams"
              [schoolYearId]="reportingYear.id"
              [otherSupportSessionsParams]="otherSupportSessionsParams"
              [user]="user" />
          </div>
        </div>
      </div>
      <div class="row gy-3 mb-3">
        <div class="col">
          <div class="h-100">
            <app-card-coach-quick-stats />
          </div>
        </div>
      </div>
      <div *ngIf="activityFeedEnabled" class="row gy-3 mb-3">
        <div
          class="col order-2"
          [ngClass]="{
            'order-2': smartAssistantEnabled
          }">
          <app-card-ideas />
        </div>
        <div
          class="col"
          [ngClass]="{
            'order-1': smartAssistantEnabled
          }">
          <app-card-todos />
        </div>
      </div>
    </div>
    <div class="col-xl-4">
      <app-card-upcoming-sessions class="d-block mb-3" />
      <ng-container *ngIf="instantFeedbackEnabled">
        <app-card-smart-feedback />
      </ng-container>
      <ng-container *ngIf="smartSuggestionsEnabled">
        <app-card-smart-suggestions
          (customActionClicked)="customSuggestionAction($event)" />
      </ng-container>
      <ng-container *ngIf="!activityFeedEnabled; else activityFeedTemplate">
        <div class="row gy-3 mb-3">
          <div class="col"><app-card-todos /></div>
        </div>
        <div class="row gy-3">
          <div class="col"><app-card-ideas /></div>
        </div>
      </ng-container>
      <ng-template #activityFeedTemplate>
        <app-card-activity-feed
          [activityStreamToken]="user?.activityStreamToken"
          [districtId]="user?.district?.id"
          [districtTimezone]="user?.district?.timezone" />
      </ng-template>
    </div>
  </div>
</div>
